import React from "react";
import { BrowserView, MobileView } from "react-device-detect";
import Slider from "react-slick";

import styles from "../../css/newsEvents.module.css";

import {
  APIIMAGE_URL,
  API_TOKEN_NAME,
  IMAGE_URL,
  USER_ID,
  USER_LOCAL_ID,
} from "../../constants";
const CareerSlider = ({ section }) => {
  const settings = {
    rows: 1,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const mobileSettings = {
    rows: 1,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <section className="container ">
      <h3
        className="text-center"
        style={{
          color: "#AF9763",
          fontSize: "28px",
          fontWeight: "500",
        }}
      >
        {section.sectionTitle}
      </h3>
      <div className="row mt-4">
        <div className="col-md-12 right-sp-1">
          <div className="news_section">
            <div className="row">
              <MobileView className={styles.MobileView}>
                <Slider {...mobileSettings}>
                  {section.value.length > 0 ? (
                    section.value.map((card) => {
                      return (
                        <div
                          className="col-sm-3 px-1"
                          key={card.id}
                          style={{ width: "100%", maxWidth: "432px" }}
                        >
                          <div
                            className="card py-4 d-flex flex-column justify-content-between align-items-start"
                            style={{
                              paddingLeft: "0px",
                              paddingRight: "0px",
                              borderRadius: "14px",
                              cursor: "pointer",
                            }}
                          >
                            {/* <a
                            href={"/news/" + newsevent_data.Slug}
                            style={{ textDecoration: "none" }}
                          > */}
                            <div
                              // style={{ background: "red" }}
                              className="card-body d-flex justify-content-start align-items-start ps-3 p-0  pt-1 mb-4"
                            >
                              <div>
                                <img
                                  // className="rounded-circle"
                                  src={`${IMAGE_URL}${card.media[0]}`}
                                  width={80}
                                  height={80}
                                  style={{
                                    objectFit: "cover",
                                    borderRadius: "5px",
                                  }}
                                  alt="news_events_1"
                                />
                              </div>

                              <div className="authorDetails d-flex flex-column align-items-start ms-3">
                                <h3
                                  style={{
                                    fontSize: "26px",
                                    color: "#222222",
                                    fontWeight: "700",
                                  }}
                                >
                                  {card.title}
                                </h3>
                              </div>
                            </div>
                            <div
                              className="px-3"
                              style={{ height: "4em" }}
                              dangerouslySetInnerHTML={{
                                __html: card.description
                                  .split(" ")
                                  .slice(0, 10)
                                  .join(" "),
                              }}
                            >
                              {/* <p
                                className="p-2"
                                style={{
                                  textAlign: "left",
                                  fontSize: "14px",
                                  color: "#B5B5B6",
                                }}
                              >
                                {card.description}
                              </p> */}
                            </div>{" "}
                            {/* </a> */}
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div className="col-sm-12 post-slide">
                      <div className="news-part">
                        <div className="bg-color-back">
                          <p>No any news & events founds</p>
                        </div>
                      </div>
                    </div>
                  )}
                </Slider>
              </MobileView>

              <BrowserView>
                <Slider className="slider-1 " {...settings}>
                  {section.value.length > 0 ? (
                    section.value.map((card) => {
                      return (
                        <div
                          className="col-sm-3 px-1"
                          key={card.id}
                          style={{ width: "100%", maxWidth: "432px" }}
                        >
                          <div
                            className="card py-4 d-flex flex-column justify-content-between align-items-start"
                            style={{
                              paddingLeft: "0px",
                              paddingRight: "0px",
                              borderRadius: "14px",
                              cursor: "pointer",
                            }}
                          >
                            {/* <a
                            href={"/news/" + newsevent_data.Slug}
                            style={{ textDecoration: "none" }}
                          > */}
                            <div
                              // style={{ background: "red" }}
                              className="card-body d-flex justify-content-start align-items-start ps-3 p-0  pt-1 mb-4"
                            >
                              <div>
                                <img
                                  // className="rounded-circle"
                                  src={`${IMAGE_URL}${card.media[0]}`}
                                  width={80}
                                  height={80}
                                  style={{
                                    objectFit: "cover",
                                    borderRadius: "5px",
                                  }}
                                  alt="news_events_1"
                                />
                              </div>

                              <div className="authorDetails d-flex flex-column align-items-start ms-3">
                                <h3
                                  style={{
                                    fontSize: "26px",
                                    color: "#222222",
                                    fontWeight: "700",
                                  }}
                                >
                                  {card.title}
                                </h3>
                              </div>
                            </div>
                            <div
                              className="px-3"
                              style={{ height: "4em" }}
                              dangerouslySetInnerHTML={{
                                __html: card.description
                                  .split(" ")
                                  .slice(0, 10)
                                  .join(" "),
                              }}
                            >
                              {/* <p
                                className="p-2"
                                style={{
                                  textAlign: "left",
                                  fontSize: "14px",
                                  color: "#B5B5B6",
                                }}
                              >
                                {card.description}
                              </p> */}
                            </div>{" "}
                            {/* </a> */}
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div className="col-sm-12 post-slide">
                      <div className="news-part">
                        <div className="bg-color-back">
                          <p>No any news & events founds</p>
                        </div>
                      </div>
                    </div>
                  )}
                </Slider>
              </BrowserView>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CareerSlider;



// WEBPACK FOOTER //
// ./src/component/frontend/CareerSlider.js